import React from 'react'
import GeneralPDFDocument from './GeneralPDFDocument'
import IdeaPDFBody from './IdeaPDFDocumentComps/IdeaPDFBody'

const IdeaPDFDocument = (props) => {
  return <GeneralPDFDocument pages={[<IdeaPDFBody {...props} />]} {...props} />
}

export default IdeaPDFDocument
